// extracted by mini-css-extract-plugin
module.exports = {"header":"Wallets_header__3-DUW"};